import { Image, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import loadingImageUrl from '#src/app/pages/startAPetitionV2/shared/assets/recommended-petition-angles-loading.gif';

export const RecommendationsLoading: React.FC = () => {
	return (
		<div
			className="container mx-auto flex h-[calc(100vh-56px)] max-w-[620px] flex-col items-center justify-center gap-6 px-4 py-12 text-center md:justify-normal"
			data-testid="loading-screen"
		>
			<div>
				<Image src={loadingImageUrl} className="aspect-auto" width={220} height="auto" alt="" aria-hidden="true" />
			</div>

			<Text as="h2" variant="heading" className="w-[16ch] md:w-full">
				<Translate value="corgi.start_a_petition.loading.recommendations.heading" />
			</Text>
		</div>
	);
};
